import { Outlet } from 'react-router-dom';

const MainRoute = () => {
	return (
		<main>
			<Outlet />
		</main>
	);
};

export default MainRoute;
